
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const PrivacyPolicy = lazy(() => import('../pages/privacypolicy/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const Legal = lazy(() => import('../pages/legal/page'));
const CommunityGuidelines = lazy(() => import('../pages/community-guidelines/page'));
const AgeVerification = lazy(() => import('../pages/age-verification/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/privacypolicy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/legal',
    element: <Legal />,
  },
  {
    path: '/community-guidelines',
    element: <CommunityGuidelines />,
  },
  {
    path: '/age-verification',
    element: <AgeVerification />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
